import { AppointmentType } from '@agent/core/basket/visio/visio-basket.model';
import {
  Criteria,
  CriteriaOperator,
  FieldList,
  Filter,
  FilterOperator,
  VisioFields,
  WorkField,
} from '@agent/core/channel-digit/visio/models/visio-request-queries';
import { isString } from 'angular';

export interface BasketFilter {
  build(): Criteria;
  isEmpty(): boolean;
}

export class AppointmentTypeFilter implements BasketFilter {
  constructor(public readonly value: AppointmentType | undefined) {}
  isEmpty(): boolean {
    return this.value == null;
  }
  build(): Criteria {
    let criteria: Criteria = {};
    criteria.column = VisioFields.TYPE;
    criteria.workfield = WorkField.KEYWORD;
    criteria.operator = CriteriaOperator.TERM;
    criteria.valuesSearch = this.value == null ? '' : this.value.valueOf();
    return criteria;
  }
}

export class ContactFilter implements BasketFilter {
  constructor(public readonly value: string = '') {}
  isEmpty(): boolean {
    return !isString(this.value) || this.value.length === 0;
  }
  build(): Criteria {
    let criteria1: Criteria = {};
    criteria1.column = VisioFields.CONTACT_FIRSTNAME;
    criteria1.workfield = WorkField.KEYWORD;
    criteria1.operator = CriteriaOperator.PREFIX;
    criteria1.valuesSearch = this.value == null ? '' : this.value.valueOf();
    let criteria2: Criteria = {};
    criteria2.column = VisioFields.CONTACT_LASTNAME;
    criteria2.workfield = WorkField.KEYWORD;
    criteria2.operator = CriteriaOperator.PREFIX;
    criteria2.valuesSearch = this.value == null ? '' : this.value.valueOf();
    let fields: FieldList = new FieldList(FilterOperator.SHOULD, [criteria1, criteria2]);
    let filter: Filter = {
      type: 'bool',
      fields: [fields],
    };
    return {
      filter: filter,
    };
  }
}

export class AgentFilter implements BasketFilter {
  constructor(public readonly value: string = '') {}
  isEmpty(): boolean {
    return !isString(this.value) || this.value.length === 0;
  }
  build(): Criteria {
    let criteria1: Criteria = {};
    criteria1.column = VisioFields.CSR_FIRSTNAME;
    criteria1.workfield = WorkField.KEYWORD;
    criteria1.operator = CriteriaOperator.PREFIX;
    criteria1.valuesSearch = this.value == null ? '' : this.value.valueOf();
    let criteria2: Criteria = {};
    criteria2.column = VisioFields.CSR_LASTNAME;
    criteria2.workfield = WorkField.KEYWORD;
    criteria2.operator = CriteriaOperator.PREFIX;
    criteria2.valuesSearch = this.value == null ? '' : this.value.valueOf();
    let criteria3: Criteria = {};
    criteria3.column = VisioFields.CSR_LOGIN;
    criteria3.workfield = WorkField.KEYWORD;
    criteria3.operator = CriteriaOperator.PREFIX;
    criteria3.valuesSearch = this.value == null ? '' : this.value.valueOf();
    let fields: FieldList = new FieldList(FilterOperator.SHOULD, [criteria1, criteria2, criteria3]);
    let filter: Filter = {
      type: 'bool',
      fields: [fields],
    };
    return {
      filter: filter,
    };
  }
}

export class ParticipantFilter implements BasketFilter {
  constructor(public readonly value: string) {}
  isEmpty(): boolean {
    return !isString(this.value) || this.value.length === 0;
  }
  build(): Criteria {
    let criteria1: Criteria = {};
    criteria1.column = VisioFields.PARTICIPANT_FIRSTNAME;
    criteria1.workfield = WorkField.KEYWORD;
    criteria1.operator = CriteriaOperator.PREFIX;
    criteria1.valuesSearch = this.value == null ? '' : this.value.valueOf();
    let criteria2: Criteria = {};
    criteria2.column = VisioFields.PARTICIPANT_LASTNAME;
    criteria2.workfield = WorkField.KEYWORD;
    criteria2.operator = CriteriaOperator.PREFIX;
    criteria2.valuesSearch = this.value == null ? '' : this.value.valueOf();
    let criteria3: Criteria = {};
    criteria3.column = VisioFields.PARTICIPANT_LOGIN;
    criteria3.workfield = WorkField.KEYWORD;
    criteria3.operator = CriteriaOperator.PREFIX;
    criteria3.valuesSearch = this.value == null ? '' : this.value.valueOf();
    let fields: FieldList = new FieldList(FilterOperator.SHOULD, [criteria1, criteria2, criteria3]);
    let filter: Filter = {
      type: 'bool',
      fields: [fields],
    };
    return {
      filter: filter,
    };
  }
}

export class SkillsFilter implements BasketFilter {
  constructor(public readonly value: string[] = []) {}

  isEmpty(): boolean {
    return this.value.length < 1;
  }

  build(): Criteria {
    let criteria: Criteria = {};
    criteria.column = VisioFields.SKILLS_LIST_UUID;
    criteria.workfield = WorkField.KEYWORD;
    criteria.operator = CriteriaOperator.TERMS;
    criteria.valuesSearch = this.value;
    return criteria;
  }
}

export class PeriodFilter implements BasketFilter {
  constructor(public readonly begin: Date, public readonly end: Date) {}
  isEmpty(): boolean {
    return this.begin == null || this.end == null;
  }
  build(): Criteria {
    let criteria: Criteria = {};
    criteria.column = VisioFields.START_DATE;
    criteria.operator = CriteriaOperator.RANGE;
    criteria.range = { from: this.begin, fromIncluded: true, to: this.end, toIncluded: true };
    return criteria;
  }
}
